import { SITE } from "redux/constants/Site";

export const setConnectionError = (load) => {
  return {
    type: SITE.CONNECTION_ERROR,
    load,
  };
};
